import { connect } from 'react-redux'
import HeaderView from '../components/HeaderView'
import {changeViewState} from "../../../store/viewState";

const mapDispatchToProps = {
  changeViewState: changeViewState
};

const mapStateToProps = (state) => ({
  view_state: state.view_state,
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderView)


// WEBPACK FOOTER //
// ./src/layouts/Header/containers/HeaderContainer.js